import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  WeekdaysArray,
  BaseShiftIcons,
  BaseShiftsArray,
  BaseStaffRequestFormInterface,
  NewInquiryFormInterface,
} from 'base';

@Component({
  selector: 'base-customer-weekdays-and-shifts',
  templateUrl: './base-customer-weekdays-and-shifts.component.html',
})
export class BaseCustomerWeekdaysAndShiftsComponent {
  @Input() form: FormGroup<BaseStaffRequestFormInterface> | FormGroup<NewInquiryFormInterface>;
  @Input() submitted = false;
  @Input() flexShift = false;

  baseShiftIcons = BaseShiftIcons;
  shifts = BaseShiftsArray;
  weekdaysArray = WeekdaysArray;
}
